module.exports = __webpack_public_path__ + "img/avax.73675597.png";